import store from "../redux";

/**
 * Endpoint patterns for deviceless API routing.
 * These are the specific endpoint suffixes that have deviceless versions.
 */
const DEVICELESS_ENDPOINT_PATTERNS = [
  "/inbox/flags",
  "/ack/alerts/v2",
  "/escalated-flagged/v2",
  "/patient/", // Covers: /patient/{id}/flags and /patient/{id}/escalated-flagged/v2
  "/psn_v2/alert/", // Covers: /psn_v2/alert/{id}/ack
  "/clinical-listing",
  "/my/watchlist/v2/patients/details",
] as const;

export const getDevicelessApiEndpoint = (url: string): string => {
  const clinic = store.getState().clinic.userClinic;
  const user = store.getState().auth.user;
  if (!user?.email?.endsWith("@circadia.health")) {
    return url;
  }

  if (clinic?.is_device_installed !== 0) {
    return url;
  }

  // Check if URL matches any deviceless endpoint pattern
  const hasDevicelessVersion = DEVICELESS_ENDPOINT_PATTERNS.some((pattern) => {
    // Use endsWith for exact suffix matching (avoids false positives)
    if (url.endsWith(pattern)) {
      return true;
    }
    // For patterns ending with '/', check if URL contains pattern followed by an ID
    if (pattern.endsWith("/") && url.includes(pattern)) {
      // Verify it's followed by a number or UUID (not another path segment)
      const afterPattern = url.split(pattern)[1];
      return afterPattern && /^[a-zA-Z0-9-]+/.test(afterPattern);
    }
    return false;
  });

  return hasDevicelessVersion ? `${url}-deviceless` : url;
};
